<template>
  <div style="background: #1f1c1f;">
    <div class="header">
      <div class="header_content">
        <div class="img">
          <h1 class="platform-name">Safe Sex</h1>
        </div>
        <div style="display: flex; align-items: center;">
          <img src="/img/record.png" alt="" style="width: 20px; height: 20px; cursor: pointer;" @click="$router.push({path:'/GameRecord'});" />
          <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
          <div v-else></div>
        </div>
        
        <!-- <div style="display: flex; " v-if="!hasToken" @click="toLogin('/Login')">
          <van-icon name="chat-o" color="#f3c7a2" size="24" />
          {{$t("auth.login")}}
        </div>
        <div v-else @click="toLogin('/ServiceOnline')">
          <van-icon name="chat-o" color="#f3c7a2" size="24" />
        </div> -->
      </div>
    </div>
    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v,key) in banners" :key="key">
            <van-image 
              class="banner_img" 
              :src="v.url" 
              width="100%" 
              height="160px"
              @error="handleImageError"
            >
              <template v-slot:loading>
                <van-loading type="circular"/>
              </template>
              <template v-slot:error>
                <div class="error-placeholder">{{$t("index.image_load_failed")}}</div>
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
    </div>
    <div style="padding: 10px; ">
      <van-notice-bar
        class="notice-swiper"
        color="#f3c7a2"
        background="#313131"
        scrollable
        :text="$t('index.welcome_notice')"
      >
        <template #left-icon>
          <img
            src="/img/neww/notice.png"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>
    <div class="nav_box">
      <div class="x_p" @click="toLogin('/Lottery')">
        <img src="/img/neww/ico_vote.png" alt="" />
        <div class="text_c">{{$t("q37")}}</div>
      </div>
      <div class="x_p"  @click="toLogin('/ServiceOnline')">
        <img src="/img/neww/ico_new.png" alt="" />
        <div class="text_c">{{$t("q38")}}</div>
      </div>
      <div class="x_p"  @click="toLogin('/Video')">
        <img src="/img/neww/ico_video.png" alt="" />
        <div class="text_c">{{$t("q39")}}</div>
      </div>
      <div class="x_p"  @click="toLogin('/Choose')">
        <img src="/img/neww/ico_vip.png" alt="" />
        <div class="text_c">{{$t("q40")}}</div>
      </div>
    </div>
    <div class="wuzii" @click="toLogin('/Choose')">
      <div class="put_tit">{{$t("q41")}}：</div>
      <div class="xx_bc">
        <div v-if="hotCities.length === 0" class="no-data">{{$t("index.loading")}}</div>
        <template v-else>
          <div class="address-row">
            <div class="top_link" v-for="address in hotCities.slice(0, 5)" :key="address.id">
              {{ address.name }}
            </div>
          </div>
          <div class="address-row">
            <div class="top_link" v-for="address in hotCities.slice(5, 10)" :key="address.id">
              {{ address.name }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="wuzii_p">
      <div class="put_tit">{{$t("q52")}}</div>
      <div class="xx_bc_u" @click="toLogin('/Choose')">
        {{$t("q53")}}
      </div>
    </div>
    <!-- <div>
      <div style="margin: 10px;">
        <span style="font-size: 16px;">  {{$t("index.Highend_area")}}</span>
        <span class="sub">{{$t("index.extreme")}}</span>
      </div>
      <div
        style="
          display: flex;
          width: 100%;
          overflow-y: auto;
          flex-wrap: nowrap;
          padding: 10px;
        "
      >
        <div
          class="gdgride"
          style="margin-right: 5px;"
          v-for="(group, index) in groupedData"
          :key="index"
        >
          <div v-for="item in group" :key="item.id">
            <div
              @click="toDetail(item.id)"
              class="van-image"
              style="
                width: 100px;
                height: 100px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <span><i>{{$t("index.airborne")}}</i></span>
            <div
              style="
                position: absolute;
                bottom: 10px;
                text-align: center;
                color: rgb(255, 255, 255);
                width: 100%;
                font-size: 12px;
              "
            >
              {{ item.xuanfei_name }}
            </div>
          </div>
        </div>

        <div
        @click="toLogin('/Choose')"
          style="
            width: 23px;
            padding: 20px 5px 10px;
            height: 145px;
            margin-top: 30px;
            background: rgb(249, 249, 249);
            color: rgb(153, 153, 153);
            font-size: 12px;
          "
        >
          {{$t("concubine.ckgdsj")}}
        </div>
      </div>
    </div> -->
    <div class="tu_list">
      <div class="reserve-bg" v-for="item in datalist" :key="item.id">
        <div class="content-bg" @click="toDetail(item.id)">
          <div class="corner_tag">{{$t("index.authentication")}}</div>
          <div class="img-container">
            <van-image
              :src="item.img_url"
              class="item_img"
            >
              <template #loading>
                <van-loading type="circular"/>
              </template>
              <template #error>
                <div class="error-placeholder">{{$t("index.image_load_failed")}}</div>
              </template>
            </van-image>
          </div>
          <div class="info_box">
            <div class="name_box">
              <span class="name">{{ item.xuanfei_name }}</span>
              <span class="location">{{$t("index.default_location")}}</span>
            </div>
            <div class="stats">
              <div class="stat_item">
                <img src="/img/neww/icon_views.png" class="icon">
                <span class="stat_num">{{item.chakan}}</span>
              </div>
              <div class="stat_item">
                <img src="/img/neww/icon_love.png" class="icon">
                <span class="stat_num">{{item.dianzan}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="padding: 10px;">
      <div style="font-size: 16px;">{{$t("index.recommend")}}</div>
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
          <div  class="imgBox">
            <div
              
              class="van-image"
              style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <span ><i>{{$t("concubine.high_end")}}</i></span>
          </div>
          <div  style="width: calc(100% - 140px);">
            <div  class="top">
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    style="width: 13px; height: 13px;"
                    class="van-image__img"
                  />
                </div>
                <span >{{$t("index.authentication")}}</span>
              </div>
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    class="van-image__img"
                    style="width: 13px; height: 13px;"
                  />
                </div>
                <span >{{$t("index.video_authentication")}}</span>
              </div>
              <div
                
                style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
               {{ item.xuanfei_name }}
              </div>
            </div>
            <div  class="tags">
              <van-tag
        v-for="(tag, index) in item.flagArray"
        :key="index"
        :type="tagTypes[index]"
      >
        {{ tag }}
      </van-tag>
              
            </div>
            <div  style="display: flex; align-items: center;">
              <span
                
                style="font-size: 14px; color: rgb(102, 102, 102);"
                >{{$t("index.toll")}}：</span
              >
              <van-rate v-model="item.number"   color="#ffd21e" size="20px" />
            </div>
            <div
              
              style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
            >
            {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
            </div>
            <div  class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div
      style="
        background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139));
        width: 96%;
        margin: 0px auto 30px;
        border-radius: 8px;
        overflow: hidden;
        padding-bottom: 10px;
      "
    >
      <div
        style="
          color: rgb(255, 232, 105);
          text-align: center;
          padding: 10px 0px;
        "
      >
        當前 1590 人在線匹配
      </div>
      <div class="OnlineMatching">
   
        <div
          :style="{
            transform: `translate(0px, ${translateY}px)`,
            transition: 'transform 1s ease-in',
          }"
          ref="scrollContainer"
        >
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      hotCities: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed:800,
        autoplay:true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows : true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData,"309");
        this.getBanner(this.basicData);//获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, "Hot Lottery Data");
        if (res.data && Array.isArray(res.data)) {
          this.hotCities = res.data;
        }
      });
    },
    getAddressList() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        console.log(res, "Address Data");
        if (res.data && Array.isArray(res.data)) {
          // 将二维数组展平为一维数组
          const flatAddresses = res.data.flat();
          
          // 确保只显示前10个地址，如果不足10个，则用空对象填充
          const addresses = [...flatAddresses];
          while (addresses.length < 10) {
            addresses.push({ id: `empty-${addresses.length}`, name: '' });
          }
          
          this.hotCities = addresses.slice(0, 10);
        }
      });
    },
    getBanner(data){
      this.banners = data.banners;  // 直接使用接口返回的数据，因为URL已经是完整的
    },
    toLogin(str) {
      // 移除路径中的前导斜杠以确保正确匹配路由
      const path = str.startsWith('/') ? str.substring(1) : str;
      this.$router.push({ path });
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { page: 1 }, // 首页不传id，显示所有根据语言筛选的数据
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
         console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          item.flagArray = item.flag.split('，');
         
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
    handleImageError(err) {
      console.error('Banner image load failed:', err);
    },
    toGameRecord() {
      this.$router.push('/mine/GameRecord');
    },
  },

  mounted() {
    this.containerHeight = this.$refs.scrollContainer.clientHeight;
    this.startAnimation();
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getAddressList()
  },
};
</script>

<style lang="less" scoped>
.tu_list{
  display: flex;
  flex-wrap: wrap;
  padding: 2.5vw;
  background: #1f1c1f;
}

.reserve-bg {
  -webkit-text-size-adjust: 100%;
  word-wrap: break-word;
  font: 12px/1.5 "Microsoft YaHei",tahoma,arial,sans-serif;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  background: transparent;
  outline: none;
  font-family: Arial,Microsoft YaHei,sans-serif;
  margin: 0;
  padding: 0;
  border: 0;
  text-decoration: none;
  color: #f3c7a2;
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 50%;
  padding: 0.5rem;
}

.content-bg {
  -webkit-text-size-adjust: 100%;
  word-wrap: break-word;
  font: 12px/1.5 "Microsoft YaHei",tahoma,arial,sans-serif;
  color: #f3c7a2;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-family: Arial,Microsoft YaHei,sans-serif;
  padding: 0;
  min-height: 4.665rem;
  height: auto;
  border-radius: 0.8rem;
  border: 0.25rem solid #766350;
  margin: 0;
  background: #212121;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,0.3);
}

.img-container {
  overflow: hidden;
  border-top-left-radius: 0.55rem;
  border-top-right-radius: 0.55rem;
  width: 100%;
}

.item_img {
  width: 102%;
  aspect-ratio: 0.7;
  object-fit: cover;
  display: block;
  margin: -1px -1px 0 -1px;
}

.corner_tag{
  position: absolute;
  right: -42px;
  top: 12px;
  font-size: 0.65rem;
  padding: 2px 40px;
  background: #efcba7;
  color: #8d5825;
  transform: rotate(45deg);
  z-index: 2;
  font-weight: bold;
}

.info_box{
  padding: 0.3rem 0.8rem;
  background: linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.name_box {
  margin-bottom: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.name {
  color: #f3c7a2;
  font-size: 0.9rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 50%;
}

.location {
  font-weight: 500;
  font-size: 18px;
  color: #4a4947;
  padding: 6px 15px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  border-radius: 12px;
  margin-left: 0;
}

.stats {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.8rem;
  margin-bottom: 0;
}

.stat_item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.icon {
  width: 1rem;
  height: 1rem;
  opacity: 0.8;
}

.stat_num {
  color: #fff;
  font-size: 0.8rem;
}

.nav_box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  .x_p{
    text-align: center;
    color: #e6b98a;
    flex:1;
    img{
      height: 76px;
    }
  }
}
.put_tit{
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before{
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}
.wuzii{
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  border: 1px solid #766350;
  .xx_bc{
    display: flex;
    flex-direction: column;
    font-size: 26px;
    color: #ccc;
    padding-top: 10px;
    
    .address-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    
    .top_link{
      padding: 15px 10px;
      flex: 1;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 20%;
      min-height: 30px; /* 确保空地址也占位 */
      margin: 0 2px; /* 增加间距 */
    }
  }
}
.wuzii_p{
  margin: 26px 20px 16px;
  background: linear-gradient(120deg,#212121,#313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u{
    color: #ccc;
  }
}
.header {
  height: 13vw;
  
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;

  .img {
    height: 80px;
    display: inline-flex;
    align-items: center;
    
    .platform-name {
      font-size: 32px;
      font-weight: bold;
      color: #e6b98a;
      margin: 0;
      text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
    }
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}

.error-placeholder {
  background: #313131;
  color: #e6b98a;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.no-data {
  color: #ccc;
  text-align: center;
  padding: 20px;
  width: 100%;
  font-size: 26px;
}
</style>
